import type { Numeric } from "d3";
import { DateTime } from "luxon";

export const useScaleTimeFormat = () => {
	// Conveniant for typing
	function createFormat(format: Intl.DateTimeFormatOptions) {
		return format;
	}

	function formatTime(date: Numeric, timezone: string, locale: string) {
		const parsedDate = new Date(date.valueOf());

		const timeFormat = createFormat({
			hour12: false,
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		});

		const dateFormat = createFormat({
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});

		let datetime = DateTime.fromJSDate(parsedDate);
		if (timezone) {
			datetime = datetime.setZone(timezone);
		}
		if (locale) {
			datetime = datetime.setLocale(locale);
		}

		return `${datetime.toLocaleString(timeFormat)}#${datetime.toLocaleString(dateFormat)}`;
	}

	return { formatTime };
};
